import PricingCard from './pricing-card';

export default PricingCard;
